import React from 'react';
import { Link } from 'react-router-dom';
import { useApp } from '../context/AppContext';

const About = () => {
  const { currentUser } = useApp();
  const homeLink = currentUser ? '/events' : '/login';
  
  return (
    <div style={{ padding: '2rem', maxWidth: '800px', margin: '0 auto', lineHeight: '1.6' }}>
      <div style={{ marginBottom: '2rem', textAlign: 'center' }}>
        <Link to={homeLink} style={{ 
          color: '#007bff', 
          textDecoration: 'none', 
          fontSize: '1rem',
          padding: '0.5rem 1rem',
          border: '1px solid #007bff',
          borderRadius: '4px',
          display: 'inline-block'
        }}>← Back to {currentUser ? 'Events' : 'Login'}</Link>
      </div>
      <h1 style={{ textAlign: 'center', marginBottom: '2rem', color: '#333' }}>About Real Air Scheduling</h1>
      
      <div style={{ backgroundColor: '#f8f9fa', padding: '1.5rem', borderRadius: '8px', marginBottom: '2rem' }}>
        <p style={{ fontSize: '1.1rem', margin: '0', textAlign: 'center', color: '#666' }}>
          Comprehensive aviation management platform designed for flight schools and aviation organizations
        </p>
      </div>

      <div style={{ display: 'grid', gap: '2rem' }}>
        <section>
          <h2 style={{ color: '#007bff', borderBottom: '2px solid #007bff', paddingBottom: '0.5rem' }}>Flight Scheduling</h2>
          <p>
            Streamline aircraft and instructor scheduling with our intuitive calendar system. Manage flight reservations, 
            track availability, and coordinate resources efficiently. Our platform ensures optimal utilization of aircraft 
            and instructor time while preventing scheduling conflicts.
          </p>
        </section>

        <section>
          <h2 style={{ color: '#28a745', borderBottom: '2px solid #28a745', paddingBottom: '0.5rem' }}>Aircraft Management</h2>
          <p>
            Keep detailed records of your fleet with comprehensive aircraft tracking. Monitor maintenance schedules, 
            track flight hours, manage inspections, and ensure regulatory compliance. Our system helps maintain 
            airworthiness and extends aircraft lifecycle through proactive maintenance management.
          </p>
        </section>

        <section>
          <h2 style={{ color: '#dc3545', borderBottom: '2px solid #dc3545', paddingBottom: '0.5rem' }}>Training Progress Tracking</h2>
          <p>
            Monitor student progress throughout their aviation journey. Track flight hours, completed lessons, 
            certifications earned, and training milestones. Instructors can log training sessions and provide 
            detailed feedback to ensure students meet all requirements for their aviation goals.
          </p>
        </section>

        <section>
          <h2 style={{ color: '#6f42c1', borderBottom: '2px solid #6f42c1', paddingBottom: '0.5rem' }}>Ground School Events</h2>
          <p>
            Organize and manage ground school training with our comprehensive event calendar. Schedule classes, 
            workshops, and seminars with ease. Students can register for events, make payments, and track their 
            ground school progress. Perfect for organizing recurring training sessions and special aviation events.
          </p>
        </section>

        <section>
          <h2 style={{ color: '#fd7e14', borderBottom: '2px solid #fd7e14', paddingBottom: '0.5rem' }}>Announcements System</h2>
          <p>
            Stay informed with our integrated announcements system. Important updates, safety notices, and 
            organizational communications are displayed prominently on the main calendar page. Users receive 
            notifications for unread announcements, ensuring critical information reaches everyone promptly.
          </p>
        </section>
        
        <section>
          <h2 style={{ color: '#007bff', borderBottom: '2px solid #007bff', paddingBottom: '0.5rem' }}>Complete Feature List</h2>
          
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '1.5rem', marginTop: '1rem' }}>
            <div style={{ backgroundColor: '#f8f9fa', padding: '1rem', borderRadius: '6px' }}>
              <h4 style={{ color: '#007bff', marginTop: '0' }}>Flight Scheduling & Calendar</h4>
              <ul style={{ margin: '0.5rem 0', paddingLeft: '1.2rem' }}>
                <li>Day, Week, and Month calendar views</li>
                <li>Aircraft and instructor scheduling</li>
                <li>Flight training reservations</li>
                <li>Discovery flight booking</li>
                <li>Ground lesson scheduling</li>
                <li>Solo and rental flight booking</li>
                <li>Drag-and-drop reservation management</li>
                <li>Reservation conflict detection</li>
                <li>Automatic duration calculation</li>
                <li>Maneuver selection for training flights</li>
              </ul>
            </div>
            
            <div style={{ backgroundColor: '#f0f8f0', padding: '1rem', borderRadius: '6px' }}>
              <h4 style={{ color: '#28a745', marginTop: '0' }}>User & People Management</h4>
              <ul style={{ margin: '0.5rem 0', paddingLeft: '1.2rem' }}>
                <li>Multi-role user system (Admin, Staff, Client)</li>
                <li>User profile management</li>
                <li>Contact information tracking</li>
                <li>Pilot certification management</li>
                <li>Aircraft limitations and permissions</li>
                <li>Student level tracking</li>
                <li>Instructor rate management</li>
                <li>User status controls (Active, Inactive, etc.)</li>
                <li>Password management with validation</li>
                <li>Organization role assignments</li>
              </ul>
            </div>
            
            <div style={{ backgroundColor: '#fff8e1', padding: '1rem', borderRadius: '6px' }}>
              <h4 style={{ color: '#ff9800', marginTop: '0' }}>Aircraft Management</h4>
              <ul style={{ margin: '0.5rem 0', paddingLeft: '1.2rem' }}>
                <li>Aircraft fleet tracking</li>
                <li>Maintenance scheduling</li>
                <li>Hobbs and Tach time logging</li>
                <li>Flight log management</li>
                <li>Aircraft check-in/check-out</li>
                <li>Maintenance alerts and warnings</li>
                <li>Aircraft status management</li>
                <li>Flight route tracking</li>
                <li>Aircraft rate management</li>
                <li>Ownership tracking</li>
              </ul>
            </div>
            
            <div style={{ backgroundColor: '#f0f0f8', padding: '1rem', borderRadius: '6px' }}>
              <h4 style={{ color: '#6f42c1', marginTop: '0' }}>Training & Progress</h4>
              <ul style={{ margin: '0.5rem 0', paddingLeft: '1.2rem' }}>
                <li>Student progress tracking</li>
                <li>Training requirement management</li>
                <li>Lesson logging and debrief</li>
                <li>Flight time tracking</li>
                <li>Dual instruction logging</li>
                <li>Ground instruction tracking</li>
                <li>Simulator time logging</li>
                <li>Training stage progression</li>
                <li>Completion status tracking</li>
                <li>Next flight planning</li>
              </ul>
            </div>
            
            <div style={{ backgroundColor: '#ffe6f0', padding: '1rem', borderRadius: '6px' }}>
              <h4 style={{ color: '#e91e63', marginTop: '0' }}>Instructor Features</h4>
              <ul style={{ margin: '0.5rem 0', paddingLeft: '1.2rem' }}>
                <li>Work schedule management</li>
                <li>Schedule override system</li>
                <li>Weekly availability settings</li>
                <li>Work lesson tracking</li>
                <li>Student lesson management</li>
                <li>Earnings statement generation</li>
                <li>Expense tracking and receipts</li>
                <li>Rental hours earned/used tracking</li>
                <li>Pay rate management</li>
                <li>Client lesson history</li>
              </ul>
            </div>
            
            <div style={{ backgroundColor: '#e8f5e8', padding: '1rem', borderRadius: '6px' }}>
              <h4 style={{ color: '#4caf50', marginTop: '0' }}>Financial Management</h4>
              <ul style={{ margin: '0.5rem 0', paddingLeft: '1.2rem' }}>
                <li>Lesson billing and payments</li>
                <li>Student account balances</li>
                <li>Purchase tracking</li>
                <li>Credit management</li>
                <li>Payment type tracking</li>
                <li>Expense management with receipts</li>
                <li>Earnings statement generation</li>
                <li>Aircraft rental billing</li>
                <li>Instructor payroll tracking</li>
                <li>Fee calculation automation</li>
              </ul>
            </div>
            
            <div style={{ backgroundColor: '#fff0e6', padding: '1rem', borderRadius: '6px' }}>
              <h4 style={{ color: '#ff5722', marginTop: '0' }}>Events & Ground School</h4>
              <ul style={{ margin: '0.5rem 0', paddingLeft: '1.2rem' }}>
                <li>Event calendar management</li>
                <li>Ground school scheduling</li>
                <li>Event registration system</li>
                <li>Payment processing for events</li>
                <li>Event capacity management</li>
                <li>Recurring event scheduling</li>
                <li>Event status tracking</li>
                <li>Participant management</li>
                <li>Event notifications</li>
                <li>Workshop and seminar organization</li>
              </ul>
            </div>
            
            <div style={{ backgroundColor: '#fff3e0', padding: '1rem', borderRadius: '6px' }}>
              <h4 style={{ color: '#fd7e14', marginTop: '0' }}>Announcements & Communication</h4>
              <ul style={{ margin: '0.5rem 0', paddingLeft: '1.2rem' }}>
                <li>Organization-wide announcements</li>
                <li>Unread notification system</li>
                <li>Priority message display</li>
                <li>Automatic read status tracking</li>
                <li>Safety notices and alerts</li>
                <li>Policy updates and changes</li>
                <li>Event reminders</li>
                <li>Weather advisories</li>
                <li>Maintenance notifications</li>
                <li>Training updates</li>
              </ul>
            </div>
            
            <div style={{ backgroundColor: '#f8f0ff', padding: '1rem', borderRadius: '6px' }}>
              <h4 style={{ color: '#9c27b0', marginTop: '0' }}>Document Management</h4>
              <ul style={{ margin: '0.5rem 0', paddingLeft: '1.2rem' }}>
                <li>Document upload and storage</li>
                <li>Pilot certificate tracking</li>
                <li>Medical certificate management</li>
                <li>License expiration tracking</li>
                <li>Insurance document storage</li>
                <li>Endorsement tracking</li>
                <li>Receipt image storage</li>
                <li>Document type categorization</li>
                <li>Expiration date alerts</li>
                <li>Document viewing and download</li>
              </ul>
            </div>
            
            <div style={{ backgroundColor: '#e6f7ff', padding: '1rem', borderRadius: '6px' }}>
              <h4 style={{ color: '#2196f3', marginTop: '0' }}>System Features</h4>
              <ul style={{ margin: '0.5rem 0', paddingLeft: '1.2rem' }}>
                <li>Role-based access control</li>
                <li>Data validation and security</li>
                <li>Responsive web design</li>
                <li>Real-time updates</li>
                <li>Search and filtering</li>
                <li>Data export capabilities</li>
                <li>Audit trails</li>
                <li>Backup and recovery</li>
              </ul>
            </div>
            
            <div style={{ backgroundColor: '#fff3e0', padding: '1rem', borderRadius: '6px' }}>
              <h4 style={{ color: '#ff9800', marginTop: '0' }}>Reports & Analytics</h4>
              <ul style={{ margin: '0.5rem 0', paddingLeft: '1.2rem' }}>
                <li>Flight hours reporting</li>
                <li>Aircraft utilization analysis</li>
                <li>Instructor activity reports</li>
                <li>Revenue summary reports</li>
                <li>Student progress tracking</li>
                <li>Financial performance metrics</li>
                <li>Custom date range filtering</li>
                <li>Visual charts and graphs</li>
              </ul>
            </div>
          </div>
        </section>
      </div>

      <div style={{ marginTop: '3rem', textAlign: 'center', padding: '1.5rem', backgroundColor: '#e9ecef', borderRadius: '8px' }}>
        <h3 style={{ color: '#333', marginBottom: '1rem' }}>Real Air Adventures, LLC</h3>
        <p style={{ margin: '0', color: '#666' }}>
          Empowering aviation education and flight operations through innovative scheduling and management solutions.
        </p>
      </div>
      
      <div style={{ marginTop: '2rem', textAlign: 'center' }}>
        <Link to={homeLink} style={{ 
          color: '#007bff', 
          textDecoration: 'none', 
          fontSize: '1rem',
          padding: '0.5rem 1rem',
          border: '1px solid #007bff',
          borderRadius: '4px',
          display: 'inline-block'
        }}>← Back to {currentUser ? 'Events' : 'Login'}</Link>
      </div>
    </div>
  );
};

export default About;